<div class="app-disclaimer-bg" style="overflow: hidden auto;height: var(--vh, 1vh) ;">
    <div class="row m-0 mobile-hide">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-4 col-sm-12 p-0">
            <img class="mob-outlive-logo" [src]="commonService.resource.image.outlive_chat" alt="">
        </div>
        <div class="col-md-7 p-0"></div>
    </div>
    <div class="pt-5">
        <div class="app-disclaimer-background w-100 d-flex justify-content-center">
            <img class="position-absolute mt-5" style="width: 76px;" [src]="commonService.resource.image.app_disclaimer_img" alt="">
            <img class="disclaimer-bg-image mobile-show" [src]="commonService.resource.image.app_disclaimer_bg" alt="">
            <img class="disclaimer-bg-image mobile-hide" [src]="commonService.resource.image.app_disclaimer_desktop_bg" alt="">
        </div>
    </div>
    <div class="content-container landing-page-container h-100">
        <div class="row m-0 h-100">
            <div class="col-md-2 p-0"></div>
            <div class="col-md-3 col-sm-12 p-0">
                <div class="h-100 d-flex justify-content-between flex-column" style="overflow: hidden auto;">
                    <div class="mt-5">
                        <div class="app-sub-content font-14 d-block" style="text-align: justify" [innerHTML]="('appDisclaimer.content' | translate)"></div>
                    </div>
                    <div class="w-100">
                        <button mat-button class="primary-button disclaimer-btn w-100 my-2" (click)="acceptDisclaimer()"> {{'appDisclaimer.btnContent' | translate}}</button>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-0 position-relative mobile-hide"></div>
            <div class="col-md-2 p-0 mobile-hide"></div>
        </div>
    </div>
</div>